import { useTheme } from "../../contexts/ThemeContext";

// Badge de status — aceita tanto strings PT (Pago, Pendente, Confirmado…) como
// os valores enum numéricos vindos da API (0/1/2). A normalização permite usar
// o mesmo componente em todas as listagens.

const STATUS_LABELS = {
  // Financeiro: 0 Pendente, 1 Parcial, 2 Pago
  financeiro: { 0: "Pendente", 1: "Parcial", 2: "Pago" },
  // Variantes por tipo — labels humanizados pra o usuário (enum backend igual).
  financeiro_receita: { 0: "A receber", 1: "Recebido parcial", 2: "Recebido" },
  financeiro_despesa: { 0: "Pendente", 1: "Pago parcial", 2: "Pago" },
  // Roteiro:    0 Rascunho,  1 Em montagem, 2 Confirmado, 3 Cancelado
  roteiro: { 0: "Rascunho", 1: "Em montagem", 2: "Confirmado", 3: "Cancelado" },
  // Agenda:     0 Livre,     1 Vendido,      2 Bloqueado
  agenda: { 0: "Livre", 1: "Vendido", 2: "Bloqueado" },
};

export function statusToLabel(status, kind) {
  if (typeof status === "string") return status;
  if (typeof status === "number" && kind && STATUS_LABELS[kind]) {
    return STATUS_LABELS[kind][status] ?? String(status);
  }
  return String(status);
}

export default function StatusBadge({ status, kind }) {
  const { C } = useTheme();
  const label = statusToLabel(status, kind);

  const map = {
    Pago: { bg: C.greenDim, color: C.green },
    "Pago parcial": { bg: C.accentDim, color: C.accent },
    Parcial: { bg: C.accentDim, color: C.accent },
    Pendente: { bg: C.redDim, color: C.red },
    "A receber": { bg: C.redDim, color: C.red },
    "Recebido parcial": { bg: C.accentDim, color: C.accent },
    Recebido: { bg: C.greenDim, color: C.green },
    Confirmado: { bg: C.greenDim, color: C.green },
    "Em montagem": { bg: C.blueDim, color: C.blue },
    Rascunho: { bg: C.purpleDim, color: C.purple },
    Vendido: { bg: C.accentDim, color: C.accent },
    Livre: { bg: C.greenDim, color: C.green },
    Bloqueado: { bg: C.purpleDim, color: C.purple },
    Cancelado: { bg: C.bgCard, color: C.textMuted },
  };
  const s = map[label] || { bg: C.bgCard, color: C.textMuted };

  return (
    <span
      style={{
        background: s.bg,
        color: s.color,
        padding: "8px 10px",
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.3,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
